<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">升学途径指南 ></span>
			<span>详情</span>
		</div>
		<section class="gaokao-content"><div class="guideInfo-txt" v-html="model.Infro"></div></section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			id: 0,
			model: {}
		};
	},
	// 加载
	created() {
		console.log(this.$route.query);
		this.id = this.$route.query.id;

		this.GetFurtherGuideById();
	},
	methods: {
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 返回上一级
		goBack() {
			this.$router.go(-1);
		},
		GetFurtherGuideById() {
			var that = this;

			that.$api.HtppRequest(
				'SystemData/GetFurtherGuideById?id=' + this.id,
				'GET',
				{},
				function(res) {
					console.log('获取', res);
					if (res.flag) {
						that.model = res.model;
					}
				},
				function(err) {
					console.log(err);
				}
			);
		}
	}
};
</script>

<style scoped>
.guideInfo-txt >>>  img{
	display: block;
	width: 100%;
}
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 40px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}
.guideInfo-img {
	width: 100%;
	height: auto;
	margin-bottom: 30px;
}
.guideInfo-img img {
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 5px;
}
.guideInfo-txt {
	margin-bottom: 30px;
	font-size: 14px;
	color: #333;
	text-indent: 2em;
	line-height: 28px;
}
*>>>.guideInfo-txt img{
	width: 100%;
	height: 100%;
	display: block;
	border-radius: 5px;
}
</style>
